import React, { useEffect, useState } from "react";
import { getCompanyId, getUserToken } from "../../../utils/utilityFunctions/localServices";
import { useFetchPersonInTableQuery } from "../../../utils/customer/customerTable";
import HighlightedParagraph from "../../UniversalComponents/HighlightedParagraph";
import { getInitials } from "../../../utils/utilityFunctions/stringUtility";

const EmailDropDownComponent = ({ handleEmailSelect }) => {
  const [emailDropdownData, setEmailDropdownData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const {
    data: emailApiData,
    error,
    isLoading,
  } = useFetchPersonInTableQuery({
    token: getUserToken(),
    companyId: getCompanyId(),
  });

  useEffect(() => {
    if (emailApiData && emailApiData?.data) {
      const filtered = emailApiData.data.filter((person) => {
        const search = searchTerm.toLowerCase().trim();
        if (!search) return true;
        return person.name?.toLowerCase().includes(search);
      });
      setEmailDropdownData(filtered);
    }
  }, [emailApiData, searchTerm]);

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 w-80">
      {/* Search Bar */}
      <div className="p-3 border-b border-gray-200">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search email..."
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Dropdown List */}
      <div className="max-h-80 overflow-y-auto">
        {isLoading && <div className="p-3 text-sm text-gray-500">Loading...</div>}
        {error && <div className="p-3 text-sm text-red-500">Error loading emails</div>}
        {emailDropdownData.length === 0 && !isLoading && (
          <div className="p-3 text-sm text-gray-500">No emails found</div>
        )}
        <ul className="list-none m-0 p-0">
          {emailDropdownData.map((person) => (
            <li
              key={person.id}
              className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-50 transition-colors"
              onClick={() => handleEmailSelect(person)}
            >
              {/* Avatar */}
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-blue-100 text-blue-700 font-semibold text-sm">
                {getInitials(person.name)}
              </div>

              {/* Text */}
              <div className="flex flex-col">
                <span className="font-medium text-gray-900 text-sm">
                  <HighlightedParagraph paragraph={person?.name} searchTerm={searchTerm} />
                </span>
                <span className="text-xs text-gray-500">{person?.email}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default EmailDropDownComponent;
